export const COMPLETE_ANALYSIS_CACHE_TTL_MS = 24 * 60 * 60 * 1000
export const PARTIAL_ANALYSIS_CACHE_TTL_MS = 15 * 60 * 1000

export function gearInsightsSampleStatus({
  sampleComplete = false,
  requestLimitReached = false,
  batchLimitReached = false,
} = {}) {
  if (sampleComplete) return 'complete'
  if (requestLimitReached) return 'rate-limited'
  if (batchLimitReached) return 'batch-limited'
  return 'partial'
}

export function gearInsightsCacheTtl(payload) {
  return payload?.sampleComplete
    ? COMPLETE_ANALYSIS_CACHE_TTL_MS
    : PARTIAL_ANALYSIS_CACHE_TTL_MS
}

export function hasUsableGearInsightsCache(payload, now = Date.now()) {
  if (!payload?.analysis || !payload.createdAt) return false
  return now - Number(payload.createdAt) < gearInsightsCacheTtl(payload)
}

function coverageDescription(payload) {
  const completion = payload?.sampleCompletion || {}
  const classes = `${completion.classesDone || 0}/${completion.classesTotal || 0} classes`
  const specs = `${completion.specsDone || 0}/${completion.specsTotal || 0} specs`
  return `${classes}, ${specs}`
}

function failureDescription(payload) {
  const failedProfiles = Number(payload?.failedProfileRequests || 0)
  const failedLeaderboards = Number(payload?.failedLeaderboardRequests || 0)
  const failed = failedProfiles + failedLeaderboards
  return failed ? ` ${failed} requests failed during the scan.` : ''
}

export function gearInsightsNotification(payload, { force = false } = {}) {
  const profiles = Number(payload?.characterCount || 0)
  const coverage = coverageDescription(payload)
  const failures = failureDescription(payload)

  if (payload?.sampleComplete) {
    return {
      type: 'success',
      title: force ? 'Build insights refreshed' : 'Build insights ready',
      description: `Coverage complete: ${coverage}. Analyzed ${profiles} leaderboard characters.${failures}`,
    }
  }

  const reason = payload?.requestLimitReached
    ? 'Raider.io rate limit stopped the scan.'
    : payload?.batchLimitReached
      ? 'The scan reached its request cap.'
      : 'Available leaderboard sources were exhausted before coverage was complete.'

  return {
    type: 'warning',
    title: 'Build insights partially ready',
    description: `${reason} Coverage: ${coverage}; ${profiles} characters analyzed.${failures}`,
  }
}
